








import ErrorView from '@spa/hl-app/components/error/ErrorView.vue'
import Vue from 'vue'
import { Component } from 'vue-property-decorator'

@Component({
  components: {
    ErrorView,
  },
})
export default class AuthError extends Vue {
}
